import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actions from '../../actions/CommentActions'
import { hideModal, showModal } from '../../actions/ModalActions';
import ModalRoot from '../Modal/ModalRoot';
class Comment extends Component {

    componentDidMount() {
        this.props.getAllComment();
    }

    closeModal = () => {
        this.props.hideModal();
    }


    openModal = (comment) => {
        this.props.showModal({
            open: true,
            closeModal: this.closeModal,
            comment: comment
        }, 'comment')
    }

    showAllComments = (comments) => {
        if (comments) {
            return comments.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ width: '100px' }}>{item.nameUser}</td>
                        <td style={{ width: '280px' }}>{item.comment}</td>
                        <td style={{ width: '280px' }}>{item.reply}</td>
                        <td>{item.date}</td>
                        <td>{item.idProduct}</td>
                        <td>
                            <button
                                className="btn btn-outline-info mr-3"
                                onClick={() => this.openModal(item)}
                            >Reply</button>
                            <button
                                className="btn btn-outline-warning"
                                onClick={() => this.props.deleteComment(item.id)}
                            >Delete</button>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        var { comments } = this.props;
        return (
            <div className="products__page pt-2 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="account__page--title">Products</h3>
                        </div>
                        <div className="col-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>User</th>
                                        <th>Comment</th>
                                        <th>Reply</th>
                                        <th>Date</th>
                                        <th>Product ID</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.showAllComments(comments)}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <ModalRoot hideModal={this.props.hideModal} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        comments: state.comments.listComment
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllComment: () => {
            dispatch(actions.fetchAPIAllComment())
        },
        deleteComment: (id) => {
            dispatch(actions.fetchAPIDeleteComment(id))
        },
        showModal: (modalProps, modalType) => {
            dispatch(showModal({ modalProps, modalType }))
        },
        hideModal: () => {
            dispatch(hideModal())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Comment);

